export default __webpack_public_path__ + "static/media/avatar.6954129f.svg";